import { render, staticRenderFns } from "./Iconos.vue?vue&type=template&id=5e7b2a34&lang=pug"
import script from "./Iconos.vue?vue&type=script&lang=js"
export * from "./Iconos.vue?vue&type=script&lang=js"
import style0 from "./Iconos.vue?vue&type=style&index=0&id=5e7b2a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports